<template>
    <Teleport to="body">
        <div class="toast-host" aria-live="polite" aria-atomic="false">
            <TransitionGroup name="toast">
                <div
                    v-for="toast in toasts"
                    :key="toast.id"
                    :class="['toast', `toast--${toast.type}`]"
                    :role="toast.type === 'error' ? 'alert' : 'status'"
                >
                    <span class="toast__message">{{ toast.message }}</span>
                    <button type="button" class="toast__close" aria-label="Закрыть" @click="dismiss(toast.id)">&times;</button>
                </div>
            </TransitionGroup>
        </div>
    </Teleport>
</template>

<script setup>
import { useToast } from '../../composables/useToast';

const { toasts, dismiss } = useToast();
</script>

<style scoped lang="scss">
@use '../../../scss/pages/admin/admin-tokens' as *;

.toast-host {
    position: fixed;
    right: $spacing-lg;
    bottom: $spacing-lg;
    z-index: $z-toast;
    display: flex;
    flex-direction: column;
    gap: $spacing-sm;
    max-width: min(420px, calc(100vw - 2 * #{$spacing-lg}));
    pointer-events: none;
}

.toast {
    display: flex;
    align-items: flex-start;
    gap: $spacing-md;
    padding: $spacing-md $spacing-lg;
    border-radius: $radius-lg;
    border: 1px solid $admin-border-color;
    border-left-width: 4px;
    background: $admin-bg-primary;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    font-size: $font-size-base;
    color: $admin-text-primary;
    pointer-events: auto;

    &--success { border-left-color: $admin-success-color; }
    &--info { border-left-color: $admin-primary-color; }
    &--error { border-left-color: $admin-danger-color; }
}

.toast__message {
    flex: 1;
    white-space: pre-line;
}

.toast__close {
    background: none;
    border: none;
    padding: 0;
    font-size: 1.25rem;
    line-height: 1;
    color: $admin-text-muted;
    cursor: pointer;

    &:hover { color: $admin-text-primary; }
}

.toast-enter-active,
.toast-leave-active {
    transition: opacity 0.2s ease, transform 0.2s ease;
}

.toast-enter-from,
.toast-leave-to {
    opacity: 0;
    transform: translateY(8px);
}
</style>
